import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 7F2511AE-AD30-41EB-AEEA-5CF18C81CF91
 * name electric-switch-closed
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/electric-switch-closed.svg
 * tags
 */
export const ElectricSwitchClosedIcon = createSvgIcon(<><path d="M20.83 11A3 3 0 0 0 15.18 11H8.82A3 3 0 0 0 3.17 11H1V13H3.17A3 3 0 0 0 8.82 13H15.18A3 3 0 0 0 20.83 13H23V11M6 13A1 1 0 1 1 7 12A1 1 0 0 1 6 13M18 13A1 1 0 1 1 19 12A1 1 0 0 1 18 13Z" /></>, 'ElectricSwitchClosedIcon');
export default ElectricSwitchClosedIcon